export class Auth0Exception extends Error {
  constructor(message: string, originalError: Error) {
    super(message)
    // eslint-disable-next-line no-console
    console.log('Original error:', originalError)
    this.name = 'Auth0Exception'
  }
}
